<script>
import apiServices from "@/services/yungol-services";
const XLSX = require("xlsx");
export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto; margin-top: 2px'>
    <button class="button is-danger" v-on:click="deleteEmployee()">
        <span v-tooltip="'Eliminar'" class="icon">
          <i class="material-icons">delete_forever</i>
        </span>
    </button>
    <button v-if="proceso.survey" class="button is-dark" v-on:click="sendEmail()">
        <span v-tooltip="'Enviar encuesta'" class="icon">
          <i class="material-icons">email</i>
        </span>
    </button>
    <button class="button is-link" v-on:click="downloadResponses()">
        <span v-tooltip="'Descargar Respuestas'" class="icon">
          <i class="material-icons">cloud_download</i>
        </span>
    </button>
    <button class="button is-link" v-on:click="copyLink()">
        <span v-tooltip="'Link Encuesta'" class="icon">
          <i class="material-icons">share</i>
        </span>
    </button>
  </div>`,
  data() {
    return {
      params: this.$parent.params,
    };
  },
  props: {
    proceso: Object,
  },
  methods: {
    async getEmployees() {
      this.$emit("getEmployees");
    },
    // Actions
    async deleteEmployee() {
      const config = {
        title: "¿Estás seguro?",
        text: "Al eliminar no se podrá recuperar el empleado después.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const result = await apiServices.delete(
              `/deleteoneemployee/${this.proceso._id}/${this.params.value}`,
            );
            if (result.data) {
              await this.$swal({
                text: "Empleado eliminado correctamente.",
                icon: "success",
                showConfirmButton: false,
                timer: 1700,
              });
              this.params.api.applyTransaction({
                remove: [this.params.node.data],
              });
              this.$emit("getEmployees");
            }
          } catch (err) {
            await this.$swal({
              text: "Error al eliminar el empleado.",
              icon: "error",
              showConfirmButton: false,
              timer: 1700,
            });
            console.log(err);
          }
        }
      });
    },
    async sendEmail() {
      let result;
      const d = {
        id: this.params.value,
      };
      try {
        result = await apiServices.post(`/enviarcorreoclima`, d);
        // this.datafile = result.data;
        if (result.data) {
          this.$store.dispatch("notify", {
            message: "Correo enviado con éxito.",
          });
        }
        this.getEmployees();
      } catch (error) {
        console.log(error);
      }
    },
    downloadResponses() {
      const d = [this.params.data.responses, this.params.data.nombre];
      if (d[0]) {
        this.dataToExport = [];
        this.dataToExport.push(d[0]);

        // Se parsea el valor boleano a texto
        this.dataToExport[0].agree
          ? (this.dataToExport[0].agree = "Si")
          : (this.dataToExport[0].agree = "No");

        //  Asignamos la informacion necesaria a nuevas variables
        let name = "CL7-Respuestas " + d[1];
        //  Se agrega la data al libro de excel
        var ws = XLSX.utils.json_to_sheet(this.dataToExport);

        //  Se configura el tamaño de cada columna
        const widths = this.widthCols(this.dataToExport);
        ws["!cols"] = widths;

        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Respuestas");
        var nombreArchivo = name + ".xlsx";
        XLSX.writeFile(wb, nombreArchivo);
      } else {
        this.$store.dispatch("notify", {
          message: `Este Usuario no tiene respuestas`,
          type: "is-danger",
        });
      }
    },
    copyLink() {
      let textArea = document.createElement("textarea");

      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = "transparent";

      textArea.value =
        window.location.host + "/encuestaclima/" + this.params.value;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "¡Copiado al portapapeles!" : "Error al copiar";
        let type = successful ? "is-link" : "is-danger";

        this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    // Helpers
    widthCols(data) {
      let values = [];
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = { width: String(data[i][d]).length + 2 };
            values.push(w);
          }
          //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = String(data[i][d]).length + 2;
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = String(key).length + 2;
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values;
    },
  },
};
</script>

<style>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/ButtonsActionSurvey.vue